import React from 'react';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';

const Footer = ({ className }) => {
  return (
    <footer className={`footer position-sticky ${className}`}>
      <a href="https://www.workglow.in/" className="footerLink">
      <div className='footer-logo-containerhead'> 
        <p className="bglogo"></p>
        <p className="SAPlogo"></p>
      </div>
        <ElectricBoltIcon style={{ fontSize: '1.2em', margin: '0 5px', color: 'black' }} />
        <p className="text-center copyright">
          Powered by Workglow Solutions
        {/* Powered by W<span className="wgcolor">o</span>rkgl<span className="wgcolor">o</span>w Solutions */}
        </p>
      </a>
    </footer>
  );
};

export default Footer;


